export default [
  {
    path: "/:cid/digital-process",
    name: "DigitalProcessHome",
    component: () => import("@/views/DigitalProcess/DigitalProcessHome.vue"),
    meta: { title: "Quy trình số", requiresAuth: true },
  },
  {
    path: "/:cid/ticket-categories",
    name: "TicketCategories",
    component: () => import("@/views/DigitalProcess/TicketCategories.vue"),
    meta: { title: "Danh mục Ticket", requiresAuth: true },
  },
  {
    path: "/:cid/tickets",
    name: "Tickets",
    component: () => import("@/views/DigitalProcess/Tickets.vue"),
    meta: { title: "Quy trình tác nghiệp (Ticket)", requiresAuth: true },
  },
  {
    path: "/:cid/payment-requests",
    name: "PaymentRequests",
    component: () => import("@/views/DigitalProcess/PaymentRequests.vue"),
    meta: { title: "Đề nghị thanh toán", requiresAuth: true },
  },
  {
    path: "/:cid/advance-requests",
    name: "AdvanceRequests",
    component: () => import("@/views/DigitalProcess/AdvanceRequests.vue"),
    meta: { title: "Đề nghị tạm ứng", requiresAuth: true },
  },
  {
    path: "/:cid/business-trips",
    name: "BusinessTrips",
    component: () => import("@/views/DigitalProcess/BusinessTrips.vue"),
    meta: { title: "Đi công tác", requiresAuth: true },
  },
  {
    path: "/:cid/reward-proposals",
    name: "RewardProposals",
    component: () => import("@/views/DigitalProcess/RewardProposals.vue"),
    meta: { title: "Đề nghị khen thưởng", requiresAuth: true },
  },
  {
    path: "/:cid/training-requests",
    name: "TrainingRequests",
    component: () => import("@/views/DigitalProcess/TrainingRequests.vue"),
    meta: { title: "Đề nghị đào tạo", requiresAuth: true },
  },
  {
    path: "/:cid/qualification-supplements",
    name: "QualificationSupplements",
    component: () =>
      import("@/views/DigitalProcess/QualificationSupplements.vue"),
    meta: { title: "Đề nghị bổ sung bằng cấp", requiresAuth: true },
  },
  {
    path: "/:cid/employee-info-changes",
    name: "EmployeeInfoChanges",
    component: () => import("@/views/DigitalProcess/WorkflowRequests.vue"),
    props: { kind: "profile" },
    meta: { title: "Thay đổi thông tin nhân sự", requiresAuth: true },
  },
  {
    path: "/:cid/disciplinary-proposals",
    name: "DisciplinaryProposals",
    component: () => import("@/views/DigitalProcess/WorkflowRequests.vue"),
    props: { kind: "discipline" },
    meta: { title: "Đề nghị kỷ luật", requiresAuth: true },
  },
  {
    path: "/:cid/resignation-requests",
    name: "ResignationRequests",
    component: () => import("@/views/DigitalProcess/WorkflowRequests.vue"),
    props: { kind: "resignation" },
    meta: { title: "Đơn xin nghỉ việc", requiresAuth: true },
  },
  {
    path: "/:cid/purchase-process",
    name: "PurchaseProcessHome",
    component: () => import("@/views/DigitalProcess/PurchaseProcessHome.vue"),
    meta: { title: "Mua hàng", requiresAuth: true },
  },
  {
    path: "/:cid/supply-proposals",
    name: "SupplyProposals",
    component: () => import("@/views/DigitalProcess/SupplyProposals.vue"),
    meta: { title: "Đề xuất cung ứng", requiresAuth: true },
  },
  {
    path: "/:cid/purchase-prices",
    name: "PurchasePrices",
    component: () => import("@/views/DigitalProcess/PurchasePrices.vue"),
    meta: { title: "Bảng giá mua", requiresAuth: true },
  },
  {
    path: "/:cid/supply-configuration",
    name: "SupplyConfiguration",
    component: () => import("@/views/DigitalProcess/SupplyConfiguration.vue"),
    meta: { title: "Danh mục & Quy trình", requiresAuth: true },
  },
  {
    path: "/:cid/supply-workflows",
    name: "SupplyWorkflows",
    component: () => import("@/views/DigitalProcess/SupplyConfiguration.vue"),
    meta: { title: "Quy trình đề xuất cung ứng", requiresAuth: true },
  },
  {
    path: "/:cid/purchase-requests",
    name: "PurchaseRequests",
    component: () => import("@/views/DigitalProcess/PurchaseRequests.vue"),
    meta: { title: "Đề nghị mua hàng", requiresAuth: true },
  },
  {
    path: "/:cid/purchase-orders",
    name: "PurchaseOrders",
    component: () => import("@/views/DigitalProcess/PurchaseOrders.vue"),
    meta: { title: "Đơn hàng mua hàng", requiresAuth: true },
  },
  {
    path: "/:cid/leave-requests",
    name: "LeaveRequests",
    component: () => import("@/views/DigitalProcess/LeaveRequests.vue"),
    meta: { title: "Nghỉ phép", requiresAuth: true },
  },
  {
    path: "/:cid/overtime-requests",
    name: "OvertimeRequests",
    component: () => import("@/views/DigitalProcess/OvertimeRequests.vue"),
    meta: { title: "Tăng ca", requiresAuth: true },
  },
  {
    path: "/:cid/late-early-requests",
    name: "LateEarlyRequests",
    component: () => import("@/views/DigitalProcess/LateEarlyRequests.vue"),
    meta: { title: "Đi trễ / Về sớm", requiresAuth: true },
  },
  {
    path: "/:cid/missing-attendance-requests",
    name: "MissingAttendanceRequests",
    component: () =>
      import("@/views/DigitalProcess/MissingAttendanceRequests.vue"),
    meta: { title: "Quên / Xác nhận chấm công", requiresAuth: true },
  },
  {
    path: "/:cid/recruitment-requests",
    name: "RecruitmentRequests",
    component: () => import("@/views/DigitalProcess/RecruitmentRequests.vue"),
    meta: { title: "Yêu cầu tuyển dụng", requiresAuth: true },
  },
  {
    path: "/:cid/meeting-rooms",
    name: "MeetingRooms",
    component: () => import("@/views/DigitalProcess/MeetingRooms.vue"),
    meta: { title: "Phòng họp", requiresAuth: true },
  },
  {
    path: "/:cid/meeting-room-catalog",
    name: "MeetingRoomCatalog",
    component: () => import("@/views/DigitalProcess/FacilityCatalog.vue"),
    props: { kind: "meeting" },
    meta: { title: "Danh mục Phòng họp", requiresAuth: true },
  },
  {
    path: "/:cid/business-cars",
    name: "BusinessCars",
    component: () => import("@/views/DigitalProcess/BusinessCars.vue"),
    meta: { title: "Xe công tác", requiresAuth: true },
  },
  {
    path: "/:cid/business-car-catalog",
    name: "BusinessCarCatalog",
    component: () => import("@/views/DigitalProcess/FacilityCatalog.vue"),
    props: { kind: "car" },
    meta: { title: "Danh mục Đặt xe", requiresAuth: true },
  },
  {
    path: "/:cid/office-supplies",
    name: "OfficeSupplies",
    component: () => import("@/views/DigitalProcess/OfficeSupplies.vue"),
    meta: { title: "Văn phòng phẩm", requiresAuth: true },
  },
  {
    path: "/:cid/incoming-documents",
    name: "IncomingDocuments",
    component: () => import("@/views/DigitalProcess/OfficeDocuments.vue"),
    props: { direction: "IN" },
    meta: { title: "Văn bản đến", requiresAuth: true },
  },
  {
    path: "/:cid/outgoing-documents",
    name: "OutgoingDocuments",
    component: () => import("@/views/DigitalProcess/OfficeDocuments.vue"),
    props: { direction: "OUT" },
    meta: { title: "Văn bản đi", requiresAuth: true },
  },
  {
    path: "/:cid/office-supply-catalog",
    name: "OfficeSupplyCatalog",
    component: () => import("@/views/DigitalProcess/PurchasePrices.vue"),
    props: { context: "office-supplies" },
    meta: { title: "Danh mục văn phòng phẩm", requiresAuth: true },
  },
];
